// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Icon} from './../icon/Icon'

// Mixins
import {EventBus} from '../../../mixins/event_bus/EventBus'

@Component({
    name: 'ProcessBar',
    components: {Icon},
    mixins: [
        template,
    ]
})
export class ProcessBar extends mixins(EventBus) {

    @Prop({default: 'vertical'})
    public theme!: string

    public created () {

    }
}